var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-list__item",style:(_vm.categoryStyle),on:{"click":function($event){_vm.$emit('CategorySelected', _vm.category)}}},[_c('div',{staticClass:"category-list__item__description",style:(_vm.labelStyle)},[_vm._v("\n    "+_vm._s(_vm.category.DESCRIPCION)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4698e428","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Categories/CategoryListItem.vue
// module id = null
// module chunks = 